import { inject, provideAppInitializer } from '@angular/core';
import { DeviceIdService } from './device-id.service';

/**
 * Hashes the push unique device id before the first request goes out, so
 * `AppHeadersInterceptor` can read it synchronously and no early call — the
 * token exchange included — leaves without an `x-device-id`.
 *
 * The digest never fails the boot: `resolve` answers `null` rather than
 * throwing where WebCrypto is missing, and the header is simply omitted.
 */
export function provideDeviceId() {
	return provideAppInitializer(() => inject(DeviceIdService).resolve());
}
